import { render, staticRenderFns } from "./document-previewer.vue?vue&type=template&id=73b901c3"
import script from "./document-previewer.vue?vue&type=script&lang=js"
export * from "./document-previewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports